// Mixin for glasses group filtering components
export default {
  data () {
    return {
      searchQuery: '',
      selectedVendor: '',
      selectedTags: [],
      productsCount: 0,
      selectedCategory: '',
      abortController: new AbortController()
    }
  },
  props: {
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    getCurrentSectionData () {
      return this.$store.getters['glassesGroupFiltering/getOfType'](this.type)
    },
    section () {
      if (!this.getCurrentSectionData.section) {
        return ''
      }

      return this.getCurrentSectionData.section
    },
    groupedTags () {
      if (!this.getCurrentSectionData.groupedTags) {
        return []
      }

      return this.getCurrentSectionData.groupedTags
    },
    vendors () {
      if (!this.getCurrentSectionData.vendors) {
        return []
      }

      return this.getCurrentSectionData.vendors
    },
    siteUrl () {
      return window.advAppData.url.base
    },
    categories () {
      if (!this.getCurrentSectionData.categories) {
        return []
      }

      return this.getCurrentSectionData.categories
    },
    firstCategorySlug () {
      if (this.categories.length === 0) {
        return ''
      }

      return this.categories[0].slug
    },
    wrapperClass () {
      return {
        'homepage-sunglasses-section-wrapper': this.section === 'sunglasses',
        'homepage-glasses-section-wrapper': this.section === 'glasses'
      }
    },
    groupTitle () {
      return `find.your.${this.section}`
    },
    totalNumberOfProductsLang () {
      return `find.your.${this.section}.mobile.no`
    },
    filteredVendors () {
      return this.vendors.filter(vendor => vendor.name.toLowerCase().includes(this.searchQuery.toLowerCase()))
    },
    urlPath () {
      const urlParts = []
      const queryString = new URLSearchParams()
      if (this.selectedVendor) {
        urlParts.push('vendors', this.selectedVendor)
      }
      if (this.selectedCategory) {
        urlParts.push(this.selectedCategory)
      }
      if (this.selectedTags.length > 0) {
        this.selectedTags.forEach((tag) => {
          queryString.append('προιοντα-για[]', `${tag.tagGroupName}/${tag.tagName}`)
        })
      }
      return urlParts.join('/') + '?' + queryString.toString()
    },
    url () {
      return `${this.siteUrl}${this.urlPath}`
    },
    fetchUrl () {
      return `${this.siteUrl}homepage-extras/${this.urlPath}`
    }
  },
  methods: {
    toggleVendorSelection (vendor) {
      if (this.selectedVendor === vendor) {
        this.selectedVendor = null
      } else {
        this.selectedVendor = vendor
      }
    },
    toggleTagSelection (tagGroupName, tagName, tagGroupId) {
      const selectedTag = { tagGroupName, tagName, tagGroupId }
      const index = this.selectedTags.findIndex(
        (tag) =>
          tag.tagGroupName === selectedTag.tagGroupName &&
          tag.tagName === selectedTag.tagName &&
          tag.tagGroupId === selectedTag.tagGroupId
      )

      if (index === -1) {
        this.selectedTags.push(selectedTag)
      } else {
        this.selectedTags.splice(index, 1)
      }
    },
    async getProductsCount () {
      try {
        if (this.abortController) {
          this.abortController.abort('New request')
        }
        this.abortController = new AbortController()
        const response = await fetch(this.fetchUrl, {
          signal: this.abortController.signal
        })
        if (!response.ok && response.status === 404) {
          this.productsCount = 0
        } else if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`)
        }
        const data = await response.json()
        if (!data) {
          console.error('Invalid response:', data)
          return
        }
        if ('numRows' in data) {
          this.productsCount = data.numRows
        }
      } catch (error) {
        console.error('Error fetching product count:', error)
      }
    },
    isSelectedTag (tagGroupName, tagName, tagGroupId) {
      if (this.selectedTags.length === 0) {
        return false
      }
      return this.selectedTags.some(tag =>
        tag.tagGroupName === tagGroupName &&
        tag.tagName === tagName &&
        tag.tagGroupId === tagGroupId
      )
    },
    isSelectedCategory (category) {
      return this.selectedCategory === category
    },
    setSelectedCategory (category) {
      this.selectedCategory = category
      this.selectedTags = []
      this.selectedVendor = null
    },
    getProductImageUrl (image) {
      return `${this.siteUrl}files/product_tag/${image}`
    },
    isActiveVendor (vendor) {
      return {
        active: this.selectedVendor === vendor
      }
    },
    uniqueIdPrefix (id) {
      return `${this.section}${id}`
    }
  },
  mounted () {
    if (this.categories.length > 0) {
      this.setSelectedCategory(this.categories[0].slug)
    }
  },
  watch: {
    selectedTags () {
      this.getProductsCount()
    },
    selectedVendor () {
      this.getProductsCount()
    },
    selectedCategory () {
      this.getProductsCount()
    },
    firstCategorySlug () {
      this.getProductsCount()
    }
  }
}
